(function () {
  function parse(c) {
    var m = c && c.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(function (x) { return parseFloat(x); });
    if (p.length > 3 && p[3] === 0) return null;
    return [p[0], p[1], p[2]];
  }
  function firstReal(el) {
    var k = el && el.firstElementChild;
    while (k && (/^(LINK|SCRIPT|STYLE|TEMPLATE)$/.test(k.tagName) || k.classList.contains('evp-fold') || k.offsetHeight === 0)) k = k.nextElementSibling;
    return k;
  }
  function bgOf(el) {
    for (var i = 0; i < 4 && el; i++) {
      var c = parse(getComputedStyle(el).backgroundColor);
      if (c) return c;
      el = firstReal(el);
    }
    return parse(getComputedStyle(document.body).backgroundColor) || [255, 255, 255];
  }
  function same(a, b) {
    return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]) < 6;
  }
  function mix(a, b, t) {
    return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(a[i] * (1 - t) + b[i] * t); }).join(',') + ')';
  }
  function rgb(a) { return 'rgb(' + a.join(',') + ')'; }
  function backTone(c) {
    var lum = (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
    return lum > 0.5 ? mix(c, [201, 183, 154], 0.3) : mix(c, [255, 255, 255], 0.12);
  }
  function addStyle(h) {
    var s = document.getElementById('evp-fold-style');
    if (!s) { s = document.createElement('style'); s.id = 'evp-fold-style'; document.head.appendChild(s); }
    s.textContent =
      '.evp-fold{position:relative;z-index:2;display:block;height:' + h + 'px;margin-top:-' + h + 'px;pointer-events:none;line-height:0}' +
      '.evp-fold svg{display:block;width:100%;height:100%}' +
      '@media(max-width:749px){.evp-fold{height:' + Math.round(h * 0.6) + 'px;margin-top:-' + Math.round(h * 0.6) + 'px}}';
  }
  function run() {
    var cfg = document.querySelector('[data-evp-fold]');
    document.querySelectorAll('.evp-fold').forEach(function (n) { n.remove(); });
    if (!cfg) return;
    addStyle(parseInt(cfg.getAttribute('data-h'), 10) || 64);
    var secs = [].slice.call(document.querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group'))
      .filter(function (s) { return s.offsetHeight > 0; });
    var prev = null;
    secs.forEach(function (sec) {
      var cur = bgOf(sec);
      if (prev) {
        var d = document.createElement('div');
        d.className = 'evp-fold';
        d.setAttribute('aria-hidden', 'true');
        d.innerHTML = '<svg viewBox="0 0 1440 100" preserveAspectRatio="none">' +
          '<path d="M0 100L0 60Q720 -16 1440 60L1440 100Z" fill="' + backTone(cur) + '"/>' +
          '<path d="M0 100L0 84Q720 16 1440 84L1440 100Z" fill="' + rgb(cur) + '"/></svg>';
        sec.insertBefore(d, sec.firstChild);
      }
      prev = cur;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (e) {
    document.addEventListener(e, function () { setTimeout(run, 60); });
  });
})();
